export const syncMessages = {
  CONFLICT: "Please resolve the conflicts below before syncing.",
  CHANGED: "Sync now to ensure your items are up to date.",
  IGNORED: "This document has been marked as ignored for syncing.",
  NO_CHANGE: "All events and fields are synced and up to date."
};
